module.exports = __webpack_public_path__ + "img/icon-game-10798.18346fef.png";